import { getEnv } from "../env-utils";

const CONFIG = {
  engineering: {
    MATOMO_DASHBOARD_URL: "https://matomoapp01.azurewebsites.net/",
    MATOMO_SITE_ID: 110,
    MATOMO_CONTAINER_SRC: 'https://matomoapp01.azurewebsites.net/js/container_cCuD3HFI.js',
  },

  stage: {
    MATOMO_DASHBOARD_URL: "https://matomoapp01.azurewebsites.net/",
    MATOMO_SITE_ID: 110,
    MATOMO_CONTAINER_SRC: 'https://matomoapp01.azurewebsites.net/js/container_cCuD3HFI.js',
  },

  prod: {
    MATOMO_DASHBOARD_URL: "https://matomoapp01.azurewebsites.net/",
    MATOMO_SITE_ID: 111,
    MATOMO_CONTAINER_SRC: 'https://matomoapp01.azurewebsites.net/js/container_cCuD3HFI.js',
  }
};

export function getConfig() {
  const env = getEnv().toLowerCase();
  return CONFIG[env];
}